import React from "react"
import Layout from "../layout/Layout"
import Header from "../components/Header/Header"
import About from "../components/About/About"
import SEO from "../components/seo"
import Goals from "../components/Goals/Goals"
import Contact from "../components/Contact/Contact"
import HeroImage from "../components/HeroImage/HeroImage"
import styled from "styled-components"

const IndexPage = () => (
  <Layout>
    <SEO title="Home" />
    <OuterWrapper>
      <InnerWrapper>
        <div>
          <Header/>
          <About/>
          <Goals/>
        </div>
        <Contact/>
      </InnerWrapper>
      <HelperWrapper>
        <HeroImage/>
      </HelperWrapper>
    </OuterWrapper>
  </Layout>
)

const OuterWrapper = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  
  ${({theme}) => theme.media.tablet} {
    display: flex;
    align-items: center;
    flex-direction: column;
    padding: 15px;
    justify-content: start;
  }
`

const InnerWrapper = styled.div``

const HelperWrapper = styled.div``

export default IndexPage
